import React from "react";

// Equipment/Supplies illustration
export const SuppliesIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 520 180" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Peptide Vial (small) */}
    <g transform="translate(20, 20)">
      {/* Cap */}
      <rect x="20" y="0" width="30" height="10" rx="2" fill="hsl(var(--primary))" opacity="0.9"/>
      <rect x="17" y="9" width="36" height="5" rx="1" fill="hsl(var(--primary))" opacity="0.7"/>
      {/* Body */}
      <rect x="15" y="14" width="40" height="85" rx="5" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
      {/* Powder */}
      <rect x="18" y="70" width="34" height="25" rx="3" fill="hsl(var(--primary))" opacity="0.15"/>
      {/* Label */}
      <rect x="20" y="25" width="30" height="22" rx="2" fill="white" stroke="hsl(var(--primary))" strokeWidth="0.8"/>
      <text x="35" y="40" textAnchor="middle" fontSize="7" fontWeight="600" fill="hsl(var(--primary))">PEPTIDE</text>
      <text x="35" y="115" textAnchor="middle" fontSize="8" fill="hsl(var(--muted-foreground))">Peptide</text>
    </g>
    
    {/* Bacteriostatic Water Vial (larger) */}
    <g transform="translate(110, 5)">
      {/* Cap */}
      <rect x="15" y="0" width="40" height="12" rx="2" fill="hsl(201 59% 55%)" opacity="0.9"/>
      <rect x="12" y="11" width="46" height="6" rx="1" fill="hsl(201 59% 55%)" opacity="0.7"/>
      {/* Body */}
      <rect x="10" y="17" width="50" height="100" rx="6" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
      {/* Liquid */}
      <rect x="13" y="50" width="44" height="63" rx="4" fill="hsl(201 59% 70%)" opacity="0.2"/>
      {/* Label */}
      <rect x="15" y="28" width="40" height="20" rx="2" fill="white" stroke="hsl(201 59% 55%)" strokeWidth="0.8"/>
      <text x="35" y="42" textAnchor="middle" fontSize="7" fontWeight="600" fill="hsl(201 59% 40%)">BAC WATER</text>
      <text x="35" y="135" textAnchor="middle" fontSize="8" fill="hsl(var(--muted-foreground))">Bac Water</text>
    </g>
    
    {/* U-100 Syringe (horizontal) */}
    <g transform="translate(200, 50)">
      {/* Plunger handle */}
      <rect x="0" y="12" width="15" height="16" rx="2" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1"/>
      {/* Plunger rod */}
      <rect x="15" y="16" width="45" height="8" fill="hsl(var(--muted-foreground))" opacity="0.3"/>
      {/* Barrel */}
      <rect x="60" y="10" width="100" height="20" rx="3" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
      {/* Tick marks */}
      {[0, 20, 40, 60, 80, 100].map((pos, i) => (
        <g key={i}>
          <line x1={65 + pos * 0.9} y1="10" x2={65 + pos * 0.9} y2={i % 2 === 0 ? "16" : "14"} stroke="hsl(var(--muted-foreground))" strokeWidth="0.5"/>
        </g>
      ))}
      {/* Needle hub */}
      <rect x="160" y="15" width="15" height="10" rx="1" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1"/>
      {/* Needle */}
      <line x1="175" y1="20" x2="200" y2="20" stroke="hsl(var(--muted-foreground))" strokeWidth="1"/>
      <text x="100" y="55" textAnchor="middle" fontSize="8" fill="hsl(var(--muted-foreground))">U-100 Syringe</text>
    </g>
    
    {/* Alcohol Pad - Square with text */}
    <g transform="translate(430, 35)">
      {/* Square pad */}
      <rect x="0" y="10" width="65" height="55" rx="3" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
      {/* Inner content */}
      <text x="32" y="35" textAnchor="middle" fontSize="8" fontWeight="500" fill="hsl(var(--primary))">Alcohol Pad</text>
      <text x="32" y="48" textAnchor="middle" fontSize="10" fontWeight="600" fill="hsl(var(--primary))">70%</text>
      <text x="32" y="85" textAnchor="middle" fontSize="8" fill="hsl(var(--muted-foreground))">Alcohol Pad</text>
    </g>
  </svg>
);

// Step illustration - Clean vial
export const StepCleanIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Vial */}
    <rect x="45" y="40" width="50" height="90" rx="6" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
    <rect x="50" y="30" width="40" height="12" rx="2" fill="hsl(var(--primary))"/>
    {/* Alcohol pad wiping */}
    <g transform="translate(75, 25) rotate(15)">
      <rect x="0" y="0" width="40" height="20" rx="2" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1"/>
      <text x="20" y="13" textAnchor="middle" fontSize="6" fill="hsl(var(--muted-foreground))">70%</text>
    </g>
    {/* Motion lines */}
    <path d="M45 35 Q35 40 45 45" stroke="hsl(var(--primary))" strokeWidth="1" fill="none" opacity="0.5"/>
    <path d="M95 35 Q105 40 95 45" stroke="hsl(var(--primary))" strokeWidth="1" fill="none" opacity="0.5"/>
    <text x="70" y="150" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Clean Stoppers</text>
  </svg>
);

// Step illustration - Draw solution - Larger vial, centered label
export const StepDrawIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Larger Bac water vial */}
    <rect x="40" y="65" width="60" height="85" rx="6" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
    <rect x="47" y="55" width="46" height="12" rx="2" fill="hsl(201 59% 55%)"/>
    <rect x="43" y="95" width="54" height="51" rx="4" fill="hsl(201 59% 70%)" opacity="0.25"/>
    {/* Centered BAC WATER label */}
    <text x="70" y="85" textAnchor="middle" fontSize="7" fontWeight="600" fill="hsl(201 59% 45%)">BAC WATER</text>
    
    {/* Syringe vertical on top */}
    <g transform="translate(55, 0)">
      {/* Plunger */}
      <rect x="10" y="0" width="10" height="12" rx="1" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="0.8"/>
      <rect x="12" y="12" width="6" height="12" fill="hsl(var(--muted-foreground))" opacity="0.3"/>
      {/* Barrel */}
      <rect x="9" y="24" width="12" height="28" rx="2" fill="white" stroke="hsl(var(--border))" strokeWidth="1"/>
      {/* Liquid being drawn */}
      <rect x="10" y="38" width="10" height="12" rx="1" fill="hsl(201 59% 70%)" opacity="0.4"/>
      {/* Needle hub */}
      <rect x="11" y="52" width="8" height="5" rx="1" fill="hsl(var(--muted))"/>
      {/* Needle going into vial */}
      <line x1="15" y1="57" x2="15" y2="70" stroke="hsl(var(--muted-foreground))" strokeWidth="1"/>
    </g>
    
    {/* Upward arrow showing extraction */}
    <g transform="translate(100, 20)">
      <line x1="0" y1="35" x2="0" y2="10" stroke="hsl(var(--primary))" strokeWidth="2.5"/>
      <polygon points="0,5 -6,16 6,16" fill="hsl(var(--primary))"/>
    </g>
    
    <text x="70" y="155" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Draw Solution</text>
  </svg>
);

// Step illustration - Inject into vial - FIXED: Syringe centered over vial cap
export const StepInjectIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Smaller Peptide vial */}
    <rect x="50" y="75" width="45" height="70" rx="5" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
    <rect x="55" y="67" width="35" height="10" rx="2" fill="hsl(var(--primary))"/>
    {/* Powder at bottom */}
    <rect x="53" y="120" width="39" height="21" rx="3" fill="hsl(var(--primary))" opacity="0.15"/>
    {/* PEPTIDE label */}
    <text x="72" y="100" textAnchor="middle" fontSize="6" fontWeight="600" fill="hsl(var(--primary))">PEPTIDE</text>
    
    {/* Syringe centered over vial cap, slightly inclined */}
    <g transform="translate(52, 5) rotate(15, 20, 40)">
      {/* Plunger */}
      <rect x="15" y="0" width="10" height="12" rx="1" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="0.8"/>
      <rect x="17" y="12" width="6" height="12" fill="hsl(var(--muted-foreground))" opacity="0.3"/>
      {/* Barrel */}
      <rect x="14" y="24" width="12" height="28" rx="2" fill="white" stroke="hsl(var(--border))" strokeWidth="1"/>
      {/* Liquid inside */}
      <rect x="15" y="27" width="10" height="18" rx="1" fill="hsl(201 59% 70%)" opacity="0.4"/>
      {/* Needle hub */}
      <rect x="16" y="52" width="8" height="5" rx="1" fill="hsl(var(--muted))"/>
      {/* Needle */}
      <line x1="20" y1="57" x2="20" y2="72" stroke="hsl(var(--muted-foreground))" strokeWidth="1"/>
    </g>
    
    {/* Downward arrow showing injection */}
    <g transform="translate(105, 25)">
      <line x1="0" y1="10" x2="0" y2="35" stroke="hsl(var(--primary))" strokeWidth="2.5"/>
      <polygon points="0,40 -6,29 6,29" fill="hsl(var(--primary))"/>
    </g>
    
    {/* Droplet at vial wall */}
    <ellipse cx="80" cy="95" rx="2" ry="3" fill="hsl(201 59% 60%)" opacity="0.6"/>
    
    <text x="70" y="155" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Inject at Wall</text>
  </svg>
);

// Step illustration - Swirl/dissolve - Proper circular swirl arrows
export const StepSwirlIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Vial */}
    <rect x="45" y="45" width="50" height="85" rx="6" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
    <rect x="50" y="37" width="40" height="10" rx="2" fill="hsl(var(--primary))"/>
    {/* Dissolved solution */}
    <rect x="48" y="70" width="44" height="56" rx="4" fill="hsl(var(--primary))" opacity="0.12"/>
    {/* PEPTIDE label */}
    <text x="70" y="63" textAnchor="middle" fontSize="6" fontWeight="600" fill="hsl(var(--primary))">PEPTIDE</text>
    
    {/* Circular swirl arrows - like refresh icon */}
    {/* Left arrow - curves from bottom to top */}
    <path 
      d="M25 105 C15 90, 15 75, 30 65" 
      stroke="hsl(var(--primary))" 
      strokeWidth="3" 
      fill="none"
      strokeLinecap="round"
    />
    <polygon points="33,62 22,60 27,70" fill="hsl(var(--primary))"/>
    
    {/* Right arrow - curves from top to bottom */}
    <path 
      d="M115 65 C125 80, 125 95, 110 105" 
      stroke="hsl(var(--primary))" 
      strokeWidth="3" 
      fill="none"
      strokeLinecap="round"
    />
    <polygon points="107,108 118,110 113,100" fill="hsl(var(--primary))"/>
    
    <text x="70" y="150" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Roll Gently</text>
  </svg>
);

// Step illustration - Label vial
export const StepLabelIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Vial */}
    <rect x="40" y="45" width="50" height="85" rx="6" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
    <rect x="45" y="37" width="40" height="10" rx="2" fill="hsl(var(--primary))"/>
    {/* Solution */}
    <rect x="43" y="75" width="44" height="51" rx="4" fill="hsl(var(--primary))" opacity="0.12"/>
    {/* Label with writing */}
    <rect x="45" y="52" width="40" height="28" rx="2" fill="white" stroke="hsl(var(--primary))" strokeWidth="1"/>
    <text x="65" y="64" textAnchor="middle" fontSize="6" fill="hsl(var(--primary))">01/28/26</text>
    <text x="65" y="74" textAnchor="middle" fontSize="6" fill="hsl(var(--primary))">5mg/ml</text>
    
    {/* Sharpie pen - touching the label */}
    <g transform="translate(65, 52) rotate(-25)">
      {/* Pen body */}
      <rect x="0" y="-4" width="50" height="8" rx="1.5" fill="hsl(220 15% 20%)"/>
      {/* Pen tip (touching label) */}
      <polygon points="0,-2 0,2 -6,0" fill="hsl(220 15% 10%)"/>
      {/* Pen cap */}
      <rect x="35" y="-4" width="15" height="8" rx="1.5" fill="hsl(var(--primary))"/>
    </g>
    
    <text x="70" y="150" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Label Vial</text>
  </svg>
);

// Step illustration - Store refrigerated
export const StepStoreIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 140 160" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Refrigerator */}
    <rect x="30" y="20" width="80" height="115" rx="5" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="2"/>
    
    {/* Freezer compartment */}
    <rect x="35" y="25" width="70" height="30" rx="3" fill="hsl(201 50% 95%)" stroke="hsl(var(--border))" strokeWidth="1"/>
    {/* Snowflakes */}
    <text x="50" y="45" fontSize="14" fill="hsl(201 59% 55%)">❄</text>
    <text x="80" y="42" fontSize="10" fill="hsl(201 59% 55%)">❄</text>
    
    {/* Fridge compartment */}
    <rect x="35" y="60" width="70" height="70" rx="3" fill="hsl(201 30% 98%)" stroke="hsl(var(--border))" strokeWidth="1"/>
    
    {/* Handle */}
    <rect x="100" y="70" width="4" height="20" rx="2" fill="hsl(var(--muted-foreground))" opacity="0.6"/>
    
    {/* Vial inside */}
    <g transform="translate(50, 70)">
      <rect x="0" y="5" width="22" height="45" rx="3" fill="white" stroke="hsl(var(--border))" strokeWidth="1"/>
      <rect x="2" y="0" width="18" height="6" rx="1" fill="hsl(var(--primary))" opacity="0.8"/>
      <rect x="2" y="30" width="18" height="17" rx="2" fill="hsl(var(--primary))" opacity="0.12"/>
    </g>
    
    {/* Temperature indicator */}
    <g transform="translate(78, 75)">
      <rect x="0" y="0" width="24" height="18" rx="2" fill="hsl(201 59% 95%)" stroke="hsl(201 59% 50%)" strokeWidth="1"/>
      <text x="12" y="12" textAnchor="middle" fontSize="7" fontWeight="600" fill="hsl(201 59% 40%)">2-8°C</text>
    </g>
    
    <text x="70" y="150" textAnchor="middle" fontSize="9" fill="hsl(var(--muted-foreground))">Refrigerate</text>
  </svg>
);

// U-100 Syringe measurement illustration - FIXED: Straight needle tip
export const SyringeMeasurementIllustration = ({ className = "" }) => (
  <svg viewBox="0 0 400 120" className={className} xmlns="http://www.w3.org/2000/svg">
    {/* Syringe body */}
    <g transform="translate(30, 30)">
      {/* Plunger */}
      <rect x="0" y="15" width="20" height="20" rx="2" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1"/>
      <rect x="20" y="20" width="30" height="10" fill="hsl(var(--muted-foreground))" opacity="0.3"/>
      {/* Barrel */}
      <rect x="50" y="12" width="240" height="26" rx="4" fill="white" stroke="hsl(var(--border))" strokeWidth="1.5"/>
      
      {/* Tick marks and labels - 100 at plunger (left), 0 at needle (right) */}
      {[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0].map((val, i) => {
        const x = 55 + (i / 10) * 230;
        const isMajor = val % 20 === 0;
        return (
          <g key={i}>
            <line 
              x1={x} y1="12" 
              x2={x} y2={isMajor ? "24" : "18"} 
              stroke="hsl(var(--syringe-tick))" 
              strokeWidth={isMajor ? "1.5" : "0.5"}
            />
            {val % 20 === 0 && (
              <text x={x} y="8" textAnchor="middle" fontSize="9" fontWeight="500" fill="hsl(var(--syringe-tick))">{val}</text>
            )}
          </g>
        );
      })}
      {/* Needle hub */}
      <rect x="290" y="17" width="15" height="16" rx="2" fill="hsl(var(--muted))" stroke="hsl(var(--border))" strokeWidth="1"/>
      {/* Straight needle - no slant */}
      <line x1="305" y1="25" x2="345" y2="25" stroke="hsl(var(--muted-foreground))" strokeWidth="1.5"/>
    </g>
    
    {/* Measurement annotations */}
    <g transform="translate(30, 78)">
      <text x="55" y="0" fontSize="9" fill="hsl(var(--muted-foreground))">100 units</text>
      <text x="160" y="0" fontSize="9" fill="hsl(var(--muted-foreground))">50 units = 0.5 mL</text>
      <text x="270" y="0" fontSize="9" fill="hsl(var(--muted-foreground))">0 units</text>
    </g>
  </svg>
);

export default {
  SuppliesIllustration,
  StepCleanIllustration,
  StepDrawIllustration,
  StepInjectIllustration,
  StepSwirlIllustration,
  StepLabelIllustration,
  StepStoreIllustration,
  SyringeMeasurementIllustration,
};
